var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:'navigation ' + _vm.ui},[_c('ul',{class:'navigation__list ' + _vm.ui},_vm._l((_vm.itemsList),function(item){return _c('li',{key:item.id,class:'navigation__wrapper ' + _vm.ui,on:{"click":function($event){return _vm.actionItem(item)}}},[_c('span',{class:'navigation__item ' + _vm.ui},[_vm._v(_vm._s(item.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }